<template>
  <div class="chart-container">
    <v-chart :width="width" :height="height" :data="data" :padding="padding" class="chart">
      <v-axis/>
      <v-stack-bar position="name*count" :label="stackLabel" color="#3F8EFF"/>
    </v-chart>
    <div class="explain">
      <span class="square"></span>
      新增
    </div>
  </div>
</template>

<script>
const stackLabel = ['count', function(val) {
  return {
    position: 'middle',
    offset: 0,
    textStyle: {
      fill: '#fff',
      fontSize: 12
    }
  }
}]
export default {
  props: {
    data: {
      type: Array,
      default () {
        return [
          {
            name: '',
            count: 0
          }
        ]
      }
    }
  },
  data() {
    return {
      scale: [{
        dataKey: 'value',
        tickCount: 5,
        alias: '新增代码量'
      }],
      height: 200,
      width: this.data.length * 50 < 320 ? 320 : this.data.length * 50,
      padding: [24, 12, 24, 48],
      label: {
        textStyle: {
          fill: '#333'
        }
      },
      stackLabel
    }
  }
}
</script>
<style lang="stylus" scoped>
  .explain
    height: 20px
    line-height: 20px
    font-size: 14px
    color: #333
    text-align: center
    margin-top: 5px
    .square
      display: inline-block
      vertical-align: middle
      width: 10px
      height: 10px
      border-radius: 3px
      background-color: #3F8EFF
      margin-right: 10px
</style>
<style lang="stylus">
  .chart-container
    .chart
      div
        overflow-x: scroll
        &::-webkit-scrollbar
          display: none
</style>
